var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTearOut = function SvgTearOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.694,
    height: 27.552
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Tear out"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 567",
    fill: "none",
    stroke: "#4e4e4e",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 566"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 210",
    d: "M22.282 25.149c.8.8 1.294.232 1.95-.423s1.226-1.151.426-1.952c0 0-11.149-11.138-13.9-13.884L8.38 11.265l13.9 13.884Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 211",
    d: "m3.313 14.246.934-.919s-.412-1.131.192-1.673a1.859 1.859 0 0 1 1.625-.207l3.28-3.17s-.23-1.648.075-1.953 3.705-1.962 4.034-2.293l-.7-.7s-4.76.573-5.276 1.088c-.3.3-2.569 2.593-4.185 4.21 0 0 .4 1.155-.128 1.688s-1.74.151-1.74.151l-.948.947c-.4.4-.164.969.327 1.461l1.044 1.044c.495.493 1.062.726 1.463.326Z"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 212",
    d: "M20.733 10.477a5.4 5.4 0 0 0 6.121-1 5.355 5.355 0 0 0 1.505-4.664l-2.8 2.8-2.384.591-2.696-2.652.632-2.459L23.888.347a5.5 5.5 0 0 0-4.776 1.393 5.483 5.483 0 0 0-.932 6.186l-1.832 1.829c.805.8 1.666 1.662 2.558 2.552l1.828-1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 213",
    d: "m11.277 19.009-2.576-2.572-2.236 2.238a1.406 1.406 0 0 0-.309.455.354.354 0 0 0-.251-.034 4.223 4.223 0 1 0-1.352 8.205 4.175 4.175 0 0 0 4.025-5.6.644.644 0 0 0-.034-.138 1.459 1.459 0 0 0 .492-.321l2.241-2.233Zm-6.723 6.53a2.459 2.459 0 1 1 0-4.917 2.459 2.459 0 1 1 0 4.917Z"
  })))));
};
export default SvgTearOut;